export type RRTruckType = {
    id?: string;
    name: string;
    plate: string;
    isOwn: boolean;
    consumption: number;
    lastKm: number;
    isActive: boolean;
}

export const EMPTY_TRUCK: RRTruckType = {
    name: "",
    plate: "",
    isOwn: true,
    consumption: 0,
    lastKm: 0,
    isActive: true
}

export type RRTrucksType = RRTruckType[];
